export default {
  namespaced: true,

  state: {
    token: '',
    refreshToken: '',
  },

  getters: {
    getToken: (state) => state.token,
    getRefreshToken: (state) => state.refreshToken,
    getIsLogged: (state) => state.token !== '' && state.refreshToken !== '',
  },

  actions: {
    setToken({ commit }, payload) {
      commit('SET_TOKEN', payload);
    },
    setRefreshToken({ commit }, payload) {
      commit('SET_REFRESH_TOKEN', payload);
    },
  },

  mutations: {
    SET_TOKEN(state, payload) {
      state.token = payload;
    },
    SET_REFRESH_TOKEN(state, payload) {
      state.refreshToken = payload;
    },
  },
};
